import React from "react";
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import CodeRoundedIcon from '@material-ui/icons/CodeRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
const Header = () => {
  return (
    <header className="header" >
      

      <nav className="header__list-container">
        <ul className="header__list">
          <li>
            <a href="#logo">
              <HomeRoundedIcon fontSize="large"/>
             <span>Home</span>
             </a>
          </li>
          <li>
            <a href="#project">

            <ViewListRoundedIcon  fontSize="large"/>
             <span>Projects</span>
            </a>
          </li>
          <li>
            <a href="#skills">

            <CodeRoundedIcon  fontSize="large"/>
             <span>Skills</span>
            </a>
          </li>
          <li>
            <a href="#about">

            <InfoRoundedIcon  fontSize="large"/>
             <span>About</span>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};
export default Header;
